// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4555":"4523bc480e6ae8bf5238","6265":"8e89453de1982d3def43"}[chunkId] + ".css";
};